import { parseUrl } from '../utils/url'
import { createCookie } from '../utils/cookies'

import {
  IS_DEV,
  IS_PROD,
  IS_WEB,
  // CONSOLE_URL,
  COOKIES_TRACKING_CONSENT_COOKIE_NAME
} from '../config/'
import { getAnalyticsStatus } from './analytics'

const DEFAULT_EVENT_TRACKING_CONFIG = {
  trackOnMixpanel: true,
  trackOnGa: true
}
const DEFAULT_PAGE_TRACKING_CONFIG = {
  trackOnMixpanel: true,
  trackOnGa: true
}

export function createTrackingCookie (enabled, services = []) {
  createCookie(
    COOKIES_TRACKING_CONSENT_COOKIE_NAME,
    JSON.stringify({
      analytics: enabled,
      services
    }),
    365,
    !IS_DEV && '.snips.ai' // share across snips domains
  )
}

// can only be called from web!
export function doNotTrackEnabled () {
  return (
    window.navigator.doNotTrack === '1' || window.navigator.doNotTrack === true
  )
}

// used for tracking purposes - when we're moving to a different domain.
// f.e. snips.ai -> console.snips.ai
// as mixpanel would otherwise lose track of the user
export function addTrackingParams (url) {
  if (!IS_WEB) {
    return url
  }
  let mxd
  // if we have a separate sdk instance of mixpanel, use that.
  // means user came from a different snips site, and we've continued to follow them.
  if (
    window.mixpanel &&
    window.mixpanel.sdk &&
    window.mixpanel.sdk.get_distinct_id
  ) {
    mxd = window.mixpanel.sdk.get_distinct_id()
  } else if (window.mixpanel && window.mixpanel.get_distinct_id) {
    // otherwise, pass along the mixpanel distinct id set on this site
    mxd = window.mixpanel.get_distinct_id()
  }
  if (!mxd) {
    return url
  }
  let parsedUrl = parseUrl(url)
  parsedUrl.search +=
    (parsedUrl.search ? '&' : '?') + `mxd=${encodeURIComponent(mxd)}`
  return parsedUrl.href
}

export function trackThenLeave (e, analyticsLabel, analyticsContext, href) {
  e.preventDefault()
  trackEvent(analyticsLabel, analyticsContext)
  // arbitrary time to wait until this action has been tracked,
  // before leaving the page
  setTimeout(() => {
    window.location = href
  }, 250)
}

// export function trackThenLeaveToDevConsole (e, context) {
//   trackThenLeave(e, 'DevConsole', context, addTrackingParams(CONSOLE_URL))
// }

export function trackUser (email) {
  // hubspot
  var _hsq = (window._hsq = window._hsq || [])
  _hsq.push(['identify', { email }])
}

export function trackEvent (value, extra, config) {
  const { trackOnMixpanel, trackOnGa } = Object.assign(
    {},
    DEFAULT_EVENT_TRACKING_CONFIG,
    config
  )
  if (!IS_PROD) {
    const status = getAnalyticsStatus()
    console.info('DEV::trackEvent', {
      value,
      extra,
      analyticsStatus: status
    })
    return
  }
  if (trackOnGa && window.dataLayer && window.dataLayer.push) {
    window.dataLayer.push({
      event: value,
      eventContext: extra
    })
  }
  if (trackOnMixpanel && window.mixpanel && window.mixpanel.track) {
    window.mixpanel.track(value, { extra: extra })
  }
  window['optimizely'] = window['optimizely'] || []
  window.optimizely.push(['trackEvent', value])
}

export function trackPageView (config) {
  const { trackOnMixpanel, trackOnGa } = Object.assign(
    {},
    DEFAULT_PAGE_TRACKING_CONFIG,
    config
  )
  const pathname = window.location.pathname
  if (!IS_PROD) {
    const status = getAnalyticsStatus()
    console.info('DEV::trackPageView', {
      pathname,
      analyticsStatus: status
    })
    return
  }

  // not available on staging
  if (trackOnGa && window.dataLayer && window.dataLayer.push) {
    window.dataLayer.push({
      event: 'pageviewCustomEvent',
      pagePath: pathname
      // pageTitle is wanted by GA, but by the time this fires,
      // the documen title has not been updated yet.
      // pageTitle: window.document.title
    })
  }

  // send _all_ page views to the sdk project on mixpanel
  // so we can use it for funnels.
  // NOTE: this is quite a lof of events (data points)
  // - might make sense to only send the page people land on;
  // or just sending events during campaigns..
  if (
    trackOnMixpanel &&
    window.mixpanel &&
    window.mixpanel.sdk &&
    window.mixpanel.sdk.track
  ) {
    window.mixpanel.sdk.track('pageView', {
      pageName: document.title,
      url: window.location.href
    })
  }

  // hubspot
  var _hsq = (window._hsq = window._hsq || [])
  _hsq.push(['trackPageView'])
}

export function trackException (e) {
  if (!window.ga || !e) {
    return
  }
  window.dataLayer.push({
    event: 'exception',
    exDescription:
      'JavaScript Error ' + e.message + ' ' + e.filename + ': ' + e.lineno
  })
}
